import type { FunctionComponent } from 'react';
import { useSchoolPageBySlugQuery } from '../../../../graphql/useSchoolPageBySlugQuery';
import { mapButtonLinkVariant } from './helpers/mapButtonLinkVariant';
import { SchoolOutboundLink } from './SchoolOutboundLink';

export const SchoolOutboundLinksWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugQuery();

  if (!data?.schoolPageBySlug?.schoolContacts) return null;

  const { schoolContacts } = data.schoolPageBySlug;

  const schoolLinks = schoolContacts.map(({ title, url, rel, variant }) => {
    const buttonVariant = mapButtonLinkVariant(variant);
    return (
      <SchoolOutboundLink
        key={url}
        title={title}
        url={url}
        rel={rel || undefined}
        variant={buttonVariant}
      />
    );
  });
  return <>{schoolLinks}</>;
};
